const exportFileName = 'auction_locations';

// headers.js
const auctionLocationHeader = [
  'Name',
  'Location / IMS Code',
  'External Auction Code',
  'Auction System',
  'Purchases',
  'Returns',
  'Inspections',
  'DS Paid PSI',
  'Title Days',
  'Sale Day(s)',
  'Supplier Number',
  'Macola Inventory Code',
  'Address',
  'Location Area',
  'Return Instructions',
  'Return Emails',
  'External Auctions Email',
  'Additional Email',
];

// Replace null values with empty strings
const replaceNullData = data => data.map(obj => Object.fromEntries(
  Object.entries(obj).map(([key, value]) => [
    key,
    value !== null && value !== undefined ? value : '',
  ])
));

// Combine address fields and wrap in double quotes
const address = (street, city, state, zip) => {
  // Return an empty string if all components are missing
  if (![street, city, state, zip].some(Boolean)) return '';

  // Combine non-empty address parts
  const combinedAddress = [street, city, state].filter(Boolean).join(' ');

  // Add zip with a comma if it exists
  return zip ? `${combinedAddress}, ${zip}` : `${combinedAddress}`;
};

// Transform data for CSV export
const auctionLocationCSV = data => replaceNullData(data).map(item => ({
  Name: item.locationName,
  'Location / IMS Code': item.locationCode,
  'External Auction Code': item.auctionedgeCode,
  'Auction System': item.auctionSystem,
  Purchases: item.purchaseEnabled ? 'TRUE' : 'FALSE',
  Returns: item.acceptsReturns ? 'TRUE' : 'FALSE',
  Inspections: item.inspectionsEnabled ? 'TRUE' : 'FALSE',
  'DS Paid PSI': item.dsPaidPsiEnabled ? 'TRUE' : 'FALSE',
  'Title Days': item.titleAllowanceDays,
  'Sale Day(s)': item.saleDays,
  'Supplier Number': item.supplierNumber,
  'Macola Inventory Code': item.macolaInventoryCode,
  Address: address(
    item.locationStreet,
    item.locationCity,
    item.locationState,
    item.locationZip
  ),
  'Return Instructions': item.returnInstructions,
  'Return Emails': item.returnEmails,
  'External Auctions Email': item.externalAuctionEmails,
  'Additional Email': item.additionalEmails,
}));

export { auctionLocationHeader, auctionLocationCSV, exportFileName };
